import 'twin.macro';

import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import tw from 'twin.macro';

import { getIsAuth } from '@/app/store/slices/auth';
import { clearCustomError } from '@/app/store/slices/error';
import SignInIcon from '@/assets/images/icons/SignInIcon';
import Logo from '@/assets/images/Logo';
import { AppWrapper, BodyText, ContactItem } from '@/components';
import { DeviceInfoContext } from '@/contexts/device-info-context';
import ThemeToggle from '@/views/theme-toggle';

import PhoneIcon from '../../assets/images/icons/PhoneIcon';
import WhatsappIcon from '../../assets/images/icons/WhatsappIcon';
import Authmodal from '../auth-modal';

const MainHeader = () => {
  const [authOpen, setAuthOpen] = useState(false);
  const dispatch = useDispatch();
  const handleClearError = () => {
    dispatch(clearCustomError());
  };
  const { isMobile } = useContext(DeviceInfoContext);
  const location = useLocation().pathname;

  const isAuth = useSelector(getIsAuth);
  return (
    <>
      <div tw='bg-secondary'>
        <AppWrapper>
          <a href='/' onClick={handleClearError}>
            <Logo tw='flex-1' />
          </a>

          <div tw='flex gap-4 mr-3 ml-auto '>
            <ContactItem
              icon={<WhatsappIcon />}
              link='https://wa.me/77760595595'
              text={'+7 776 0 595 595'}
              twStyle={tw`min-w-[110px]`}
            />
            <ContactItem icon={<PhoneIcon />} link='tel:595' text={'595'} />

            <ThemeToggle />
            {!isAuth && !location.includes('prepaid') && (
              <button onClick={() => setAuthOpen(true)} tw='!min-w-[32px] max-w-[90px] !p-0 !m-0'>
                <div tw='sm:h-[32px] h-[28px] sm:w-auto w-[28px] sm:px-2 flex items-center justify-center bg-button rounded-full gap-1 '>
                  <SignInIcon />
                  {!isMobile && <BodyText text={'Войти'} twStyle={tw`text-s14 text-white`} />}
                </div>
              </button>
            )}
          </div>
        </AppWrapper>
      </div>
      <Authmodal authOpen={authOpen} setAuthOpen={setAuthOpen} />
    </>
  );
};

export { MainHeader };
